import { Box, Typography, Grid } from '@mui/material';
import { DataLakeFileSystemModel, DataLakeDirectoryModel } from '../../gql-types.generated';
import DirectoryTreeItem from './DirectoryTreeItem';

interface DirectoryTreeProps {
    directoryHierarchy?: DataLakeFileSystemModel;
    expandedPaths: Set<string>;
    activeDirectory?: DataLakeDirectoryModel;
    onDirectoryClick: (path: string) => void;
    onToggleExpand: (path: string) => void;
    disabledPaths?: string[];
}

const DirectoryTree = ({
    directoryHierarchy,
    expandedPaths,
    activeDirectory,
    onDirectoryClick,
    onToggleExpand,
    disabledPaths = []
}: DirectoryTreeProps) => {
    const validDirectories = directoryHierarchy?.rootDataLakeDirectories
        ?.filter((dir): dir is DataLakeDirectoryModel => {
            if (!dir) return false;
            if (!dir.name || !dir.path) return false;
            return true;
        }) || [];

    if (!validDirectories.length) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="body1" color="textSecondary">
                    No directories available
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ 
            height: '100%',
            padding: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box sx={{ flex: 1, overflow: 'auto' }}>
                <Grid container direction="column" spacing={1.5}>
                    {validDirectories.map(directory => (
                        <Grid item xs={12} key={directory.path}>
                            <DirectoryTreeItem
                                key={directory.path}
                                directory={directory}
                                level={0}
                                onDirectoryClick={onDirectoryClick}
                                expanded={expandedPaths.has(directory.path)}
                                onToggleExpand={onToggleExpand}
                                expandedPaths={expandedPaths}
                                activeDirectory={activeDirectory}
                                disabledPaths={disabledPaths}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default DirectoryTree;
